import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import {
  type CvAnalysisPublicDto,
  type CvAnalysisResponse,
  CvAnalysisService,
} from '@/services/api';

export const CVAnalysisKeys = {
  CVAnalysisResultQuery: (params: CVAnalysisResultParams) =>
    ['CVAnalysisResult', params] as const,
  CVAnalysisShareResultQuery: (params: CVAnalysisShareResultParams) =>
    ['CVAnalysisShareResultQuery', params] as const,
  CVAnalysisReportResultQuery: (params: CVAnalysisShareResultParams) =>
    ['CVAnalysisReportResultQuery', params] as const,
};

type CVAnalysisResultParams = {
  /**  */
  id: string;
  /**  */
  email: string;
};

export const useCVAnalysisResultQuery = (
  params: CVAnalysisResultParams,
  options?: Partial<UseQueryOptions<CvAnalysisResponse, AxiosError>>
) => {
  return useQuery({
    queryKey: CVAnalysisKeys.CVAnalysisResultQuery(params),
    queryFn: () => CvAnalysisService.getAllCvAnalysis(params),

    ...options,
  });
};

type CVAnalysisShareResultParams = {
  /**  */
  id: string;
  /**  */
  email: string;
};

export const useCVAnalysisShareResultQuery = (
  params: CVAnalysisShareResultParams,
  options?: Partial<UseQueryOptions<CvAnalysisPublicDto, AxiosError>>
) => {
  return useQuery({
    queryKey: CVAnalysisKeys.CVAnalysisShareResultQuery(params),
    queryFn: () => CvAnalysisService.getAllCvAnalysisPublic(params),

    ...options,
  });
};

type CVAnalysisReportResultParams = {
  /**  */
  id: string;
  /**  */
  email: string;
};

export const useCVAnalysisReportResultQuery = (
  params: CVAnalysisReportResultParams,
  options?: Partial<UseQueryOptions<CvAnalysisPublicDto, AxiosError>>
) => {
  return useQuery({
    queryKey: CVAnalysisKeys.CVAnalysisReportResultQuery(params),
    queryFn: () => CvAnalysisService.getAllCvAnalysisReport(params),

    ...options,
  });
};
